export const toPercentSingleDecimal = (number: number) => Math.round(number * 1000) / 10;

// Rounds up to a nicer axis max, e.g. 1.2 -> 2, 31 -> 40, 1820 -> 2000, etc.
export const getMaxCeil = (value: number): number => {
  if (value === 0) return 0;
  const baseUnit = Math.pow(10, Math.floor(Math.log10(value)));
  return Math.ceil(value / baseUnit) * baseUnit;
};
